<!-- 「更新が完了しました」等のメッセージを出力する -->
<template>
    <div id="overlay" v-if="message_flag0">
        <div id="content_modal">
            <template v-if="props.message_cat == 3">
                <div style="margin-bottom:10px">
                    <b> 【受入先用URL】<br><u>{{ facility_url }}</u></b><br>
                </div>
                受入先用ログインサイトは、別ブラウザを開いて使用してください。<br>※ 管理者用、受入先用は同じブラウザで同時に開けません。<br>
                <hr>
                <div style="margin-top:10px">
                <b>【スマートフォン用QRコード】</b>
                    <QRCodeVue3
                    v-bind:value=facility_url
                    :width="100"
                    :height="100"
                    :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                    :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
                    :dotsOptions="{
                        type: 'square',
                        color: '#000000',
                        gradient: {
                        type: 'linear',
                        rotation: 0,
                        colorStops: [
                            { offset: 0, color: '#000000' },
                            { offset: 1, color: '#000000' },
                        ],
                        },
                    }"
                    :backgroundOptions="{ color: '#ffffff' }"
                    :cornersSquareOptions="{ type: 'dot', color: '#000000' }"
                    :cornersDotOptions="{ type: undefined, color: '#000000' }"
                    fileExt="png"
                    :download="false"
                    myclass="my-qur"
                    imgclass="img-qr"
                    downloadButton="my-button"
                    :downloadOptions="{ name: 'vqr', extension: 'png' }"
                    />
                </div>
                <div class="col-md-auto" style="margin-top:10px">
                   <button  class="btn btn-secondary btn_confirm" v-on:click="Close_message()">閉じる</button>
                </div>
            </template>

            <template v-if="props.message_cat == 2">
                <div style="margin-bottom:10px">
                    <b> 【体験者用URL】<br><u>{{ taiken_url }}</u></b><br>
                </div>
                体験者用PC版は、別ブラウザを開いて使用してください。<br>※ 管理者用、体験者用は同じブラウザで同時に開けません。<br>
                <hr>
                <div style="margin-top:10px">
                <b>【スマートフォン用QRコード】</b>
                    <QRCodeVue3
                    v-bind:value=taiken_url
                    :width="100"
                    :height="100"
                    :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                    :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
                    :dotsOptions="{
                        type: 'square',
                        color: '#000000',
                        gradient: {
                        type: 'linear',
                        rotation: 0,
                        colorStops: [
                            { offset: 0, color: '#000000' },
                            { offset: 1, color: '#000000' },
                        ],
                        },
                    }"
                    :backgroundOptions="{ color: '#ffffff' }"
                    :cornersSquareOptions="{ type: 'dot', color: '#000000' }"
                    :cornersDotOptions="{ type: undefined, color: '#000000' }"
                    fileExt="png"
                    :download="false"
                    myclass="my-qur"
                    imgclass="img-qr"
                    downloadButton="my-button"
                    :downloadOptions="{ name: 'vqr', extension: 'png' }"
                    />
                </div>
                <div class="col-md-auto" style="margin-top:10px">
                   <button  class="btn btn-secondary btn_confirm" v-on:click="Close_message()">閉じる</button>
                </div>
            </template>

            <template v-else>
                <div style="padding:20px 0 30px 0" v-html="message_text">
                </div>
                <!-- message_cat=0（OKのみ）の場合はこちらを表示 -->
                <div class="row justify-content-center" v-if="alert_button">
                    <button  class="btn btn-primary btn_confirm"  v-on:click="OK_message()">OK</button>
                </div>

                <!-- message_cat=1（OK or キャンセルの選択式）の場合はこちらを表示 -->
                <div class="row justify-content-center" v-if="confirm_button">
                    <div class="col-md-auto">
                        <button  class="btn btn-primary btn_confirm" id="" v-on:click="OK_message()">OK</button>
                    </div>
                    <div class="col-md-auto">
                        <button  class="btn btn-secondary btn_confirm" v-on:click="Close_message()">キャンセル</button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
  import { useRoute } from 'vue-router'
  const route = useRoute();
  import QRCodeVue3 from "qrcode-vue3";

// このvueファイルのみで行われる処理を記述
let alert_button = false    //message_cat=0（OKのみ）の場合はこちらをtrueにする
let confirm_button = false  //message_cat=1（OK or キャンセルの選択式）の場合はこちらをtrueにする            

// 体験者URL
let taiken_url = location.protocol+"//"+location.host+"/"+route.params.shakyo+"/Taiken"

// message（表示するメッセージ）
// message_cat（0：OKのみ、1：OK or キャンセルの選択式）
// message_flag（表示・非表示フラグ）
const props = defineProps([
    "message_text",
    "message_cat",
    "message_flag",
    "message_param"
    ]);

let facility_url = ""
//受入先用URL
if(props.message_cat == 3){
    facility_url = props.message_param
}

let message_flag0 = ref(props.message_flag);

watch(props.message_flag, () => {
    // ウィンドウが表示されたときに検索を開始
    if(props.message_flag == true){
        Check();
    }
})

let Check = function(){  //表示時の確認
    alert_button = false;
    confirm_button = false;
    // message_cat（0：OKのみ、1：OK or キャンセルの選択式）
    if(props.message_cat == 0){
        alert_button = true;
    } else if (props.message_cat == 1){
        confirm_button = true;
    }
}

const emit = defineEmits(['ok_message','close_message']);

let OK_message = function(){  //このウィンドウを閉じて親コンポーネント側で処理を行う
    message_flag0 = false;
    emit('ok_message',message_flag0);
}

let Close_message = function(){  //このウィンドウを閉じる
    message_flag0 = false;
    emit('close_message',message_flag0);
}

/* 初期処理 */
Check();
</script>

<style scoped>
#overlay{
  /* 要素を重ねた時の順番 */
  z-index:1001;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}

#content_modal{
  /* 要素を重ねた時の順番 */
  z-index:1002;
    max-width: 650px;
  height:auto;
  text-align: center;
  padding: 1em;
  background:#fff;
  white-space: pre-line;
}
#content_modal button{
    width:150px;
    height:40px;
    padding: 0;
}


</style>